const TableSearch = {

    init() {
        this.el = $('[component="TableSearch"]');

        if (!this.el.length) {
            return;
        }

        this.templates = this.el.find(".templates");
        this.input = 'input[name="search"]';

        this.bind();
    },

    bind() {
        $(document).on('keyup search', TableSearch.input, function (e) {
            let input = $(e.target);
            let wrapper = input.closest(".input");
            let counter = wrapper.find(".searchCount");

            let searchIN = $(input).data('searchtarget');

            let searchValue = $(input).val().toLowerCase().trim();
            let v = searchValue.split(" ");//%

            // Counter for visible rows
            let visibleRowCount = 0;

            // Loop through each element to search in
            $(searchIN).each(function (j, k) {
                let s = true;

                $.each(v, function (i, findWord) {

                    findWord = findWord.toLowerCase();

                    if (s) {
                        let elementText = $(k).text().toLowerCase();
                        let findIN = elementText;

                        elementText =  TableSearch.sanitize(elementText);

                        findIN = findIN + elementText;

                        // Check if the element contains the word
                        s = findIN.indexOf(findWord) > -1;
                    }
                });

                $(this).toggle(s);

                if (s) {
                    visibleRowCount++;
                }
            });

            counter.text(visibleRowCount);

            if (searchValue.length === 0) {
                $(input).removeClass('withValue');
                wrapper.removeClass("found");

                $('table .hidden').removeAttr('style');

                TableSearch.sectionVisibilityReset();
            } else {
                wrapper.addClass("found");

                $(input).addClass('withValue');

                TableSearch.sectionVisibility();
            }

            TableSearch.emptyResults(searchValue);
        });
    },

    sectionVisibility() {
        TableSearch.sectionVisibilityReset();

        $.each($(".categorySection"), function (index, element) {
            let visibleRow = $(element).find(".item:visible");

            $(element).toggleClass("emptySearch", visibleRow.length === 0);
        });
    },

    sectionVisibilityReset() {
        $(".categorySection").removeClass('emptySearch');
    },

    emptyResults(searchValue) {
        let emptyContent = this.templates.find(".notFoundAlert").clone();
        let wrapper = $(".categorySection").closest("section");
        let searchEmptyAlert = wrapper.find('.notFoundAlert');

        searchEmptyAlert.find('strong').text(searchValue);

        if ($(".categorySection:visible").length === 0) {

            if (searchEmptyAlert.length === 0) {
                wrapper.append(emptyContent);
            }
        } else {
            wrapper.find(".notFoundAlert").remove();
        }
    },

    sanitize(str) {

        str = str.replace(/\s/g, '');

        // Mapping of accented characters to non-accented counterparts
        const diacriticsMap = {
            'á': 'a', 'ä': 'a', 'č': 'c', 'ď': 'd', 'é': 'e',
            'í': 'i', 'ĺ': 'l', 'ľ': 'l', 'ň': 'n', 'ó': 'o',
            'ô': 'o', 'ŕ': 'r', 'š': 's', 'ť': 't', 'ú': 'u',
            'ý': 'y', 'ž': 'z', 'Á': 'A', 'Ä': 'A', 'Č': 'C',
            'Ď': 'D', 'É': 'E', 'Í': 'I', 'Ĺ': 'L', 'Ľ': 'L',
            'Ň': 'N', 'Ó': 'O', 'Ô': 'O', 'Ŕ': 'R', 'Š': 'S',
            'Ť': 'T', 'Ú': 'U', 'Ý': 'Y', 'Ž': 'Z'
        };

        // Replace accented characters with non-accented counterparts
        str = str.replace(/[áäčďéíĺľňóôŕšťúýžÁÄČĎÉÍĹĽŇÓÔŔŠŤÚÝŽ]/g, function(match) {
            return diacriticsMap[match];
        });

        // Replace commas with hyphens
        str = str.replace(/,/g, '-');

        // Convert to lowercase
        str = str.toLowerCase();

        return str;
    }

}
export default TableSearch;